import { Card, CardString, Hand, StandardHandTypeWithRoyalFlush } from 'pokersolver'
import { logger } from './Logger'
import { getCardString } from './Poker'

// TODO: Use this everywhere
type UtilResult =
  | {
      error: false
      payload: string
    }
  | {
      error: true
      errorMessage: string
    }

export const getReadableWinCards = (
  cards: (Card | CardString)[],
  texts: Record<StandardHandTypeWithRoyalFlush, string>
): UtilResult => {
  let hand: Hand
  try {
    hand = Hand.solve(cards.map(getCardString))
    if (!hand)
      return {
        error: true,
        errorMessage: 'getReadableWinCards: Cards could not be solved into a hand'
      }
    const readableCardWinCards = texts[hand.name]
    if (readableCardWinCards) {
      return {
        error: false,
        payload: readableCardWinCards
      }
    }
    return {
      error: true,
      errorMessage: 'getReadableWinCards: "texts" did not contain the solved hand name'
    }
  } catch (error) {
    logger.error(error)
    return {
      error: true,
      errorMessage: error as string
    }
  }
}

export const cardsDifferenceWithWinners = (cards: CardString[], winningHandCards: CardString[]) => {
  // if (cards.length <= 0 || winningHandCards.length <= 0)
  //   throw new Error('cards and winningHandCards must contain elements')
  return [...(cards ?? [])].filter((card) => winningHandCards?.includes(card))
}
